import { Input, Directive } from '@angular/core';
import { MileageDetailsDto } from '@vpfa/rest-api/valuation';

@Directive()
export class BaseProvenanceCheckSectionMileageComponent {
  @Input() mileageDetails: MileageDetailsDto;
}
